import projectsList from 'data/projects.json';
import { useEffect, useState } from "react";

export function useProjects() {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        try {
            setLoading(true);
            const projectsListSorted = projectsList.sort((a, b) => a.order - b.order)
            setProjects(projectsListSorted);
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }, [])

    return { projects, loading, error }
}